import React from 'react';

// Paleta y componente de "chip" compartidos entre la grilla de Mantenimiento
// (columnas Ítem, Tipo, Estado) y la ficha del activo (historia clínica y
// diagnóstico de IA), para que ambas pantallas se vean parte del mismo sistema
// en vez de mezclar el chip propio de la grilla con los <Tag> de PrimeReact.

export const ESTADO_COLORS = {
    'Pendiente':  { bg: '#fffaeb', color: '#b54708', border: '#fedf89', dot: '#f79009' },
    'En Proceso': { bg: '#eff8ff', color: '#175cd3', border: '#b2ddff', dot: '#2e90fa' },
    'Finalizada': { bg: '#ecfdf3', color: '#12b76a', border: '#a9efc5', dot: '#12b76a' },
    'Cancelada':  { bg: '#fef3f2', color: '#f04438', border: '#fecdca', dot: '#f04438' },
};

export const TIPO_COLORS = {
    'Preventivo': { bg: '#eff8ff', color: '#175cd3', border: '#b2ddff' },
    'Correctivo': { bg: '#fef3f2', color: '#f04438', border: '#fecdca' },
    'Inspeccion': { bg: '#f4f3ff', color: '#5925dc', border: '#d9d6fe' },
};

export const TIPO_LABELS = { 'Preventivo': 'Preventivo', 'Correctivo': 'Correctivo', 'Inspeccion': 'Inspección' };

export const CONFIANZA_COLORS = {
    alta:  { bg: '#fef3f2', color: '#f04438', border: '#fecdca' },
    media: { bg: '#fffaeb', color: '#b54708', border: '#fedf89' },
    baja:  { bg: '#f2f4f7', color: '#667085', border: '#e4e7ec' },
};

export const CONFIANZA_LABELS = { alta: 'Confianza alta', media: 'Confianza media', baja: 'Confianza baja' };

// Mismo azul que "En Proceso" / "Preventivo" -- ya es el color que este
// sistema usa para "info/link", así que el nombre del activo lo reutiliza
// para que se lea como clickeable sin inventar un color nuevo.
export const ITEM_COLORS = { bg: '#eff8ff', color: '#175cd3', border: '#b2ddff' };

export const Badge = ({ label, colors, onClick, title }) => (
    <span
        onClick={onClick}
        title={title}
        style={{
            display: 'inline-block',
            background: colors.bg, color: colors.color, border: `1px solid ${colors.border}`,
            fontWeight: 600, fontSize: '0.75rem', padding: '0.15rem 0.6rem', borderRadius: 99,
            cursor: onClick ? 'pointer' : 'default',
        }}
    >
        {label}
    </span>
);
